import React, { forwardRef, useEffect } from "react";
import PromoCodeSection from "../planPartials/PromoCodeSection";
import {
  useMealsSelection,
  usePlan,
  usePromoCode,
} from "../contexts/SubscriptionContext";
import { useLocation, useParams } from "react-router-dom";
import { isSnack, isTrial } from "../utils/commonHelper";
import { useCart } from "../contexts/CartContext";
import ContainerLoading from "../common/loading/ContainerLoading";

const CartSummary = forwardRef(
  ({ cart, hideItems = false, hidePromo = false }, ref) => {
    const { type } = useParams();
    const location = useLocation();

    const mealCartId = localStorage.getItem("mealCartId");
    if (!cart) return null;
    let trialPlan = isTrial(cart?.plan?.title);

    return (
      <div
        ref={ref}
        className="bg-[#fff] rounded-[15px] p-5 lg:px-10 lg:py-10 flex flex-col justify-between  relative "
      >
        {/* {loading && (
        <div className="absolute inset-0 flex items-center justify-center rounded-[15px] z-10">
          <ContainerLoading />
        </div>
      )} */}
        {type === "meals" &&
          cart?.meals?.length > 0 &&
          cart.meals
            ?.sort((a, b) => a?.sortOrder - b?.sortOrder)
            .map((item, index) => {
              // Find the corresponding meal amount entry
              const mealAmount = cart?.invoice?.mealsAmount?.find(
                (meal) => meal?._id === item?._id,
              );

              return (
                <div
                  key={index}
                  className="grid grid-cols-[4fr_1fr] gap-10 bg-white mb-3 md:mb-0"
                >
                  {/* Meal Title + Price per Day */}
                  <div className="font-mono font-bold text-18pt text-green leading-none">
                    {isSnack(item?.title) ? "Snacks" : item?.title}{" "}
                    <span className="font-normal md:font-bold text-10pt xs:text-14pt text-nowrap">
                      ({cart?.plan?.daysInPlan} meals *{" "}
                      {trialPlan ? 0 : item?.price?.$numberDecimal || 0} AED)
                    </span>
                  </div>

                  {/* Meal Total Amount */}
                  <div className="font-mono font-bold text-18pt text-green text-right text-nowrap">
                    {mealAmount
                      ? `${mealAmount.totalAmount} AED`
                      : `${
                          (cart?.plan?.daysInPlan || 0) *
                          (item?.price?.$numberDecimal || 0)
                        } AED`}
                  </div>
                </div>
              );
            })}

        {!hideItems &&
          (type === "order" || !type) &&
          cart?.items?.length > 0 &&
          cart.items.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-[4fr_1fr] gap-2 md:gap-10 bg-[#fff] mb-3 md:mb-0 rounded-lg"
            >
              <div className="font-mono text-18pt text-green leading-tight flex items-center gap-2 overflow-hidden">
                <span
                  className="font-bold truncate"
                  style={{ maxWidth: "70%" }} // adjust as needed
                  title={item.product.title} // shows full title on hover
                >
                  {item.product.title}
                </span>
                <span className="font-normal text-10pt xs:text-14pt flex-shrink-0">
                  ({item.quantity} * {item.product.salePrice} AED)
                </span>
              </div>

              <div className="font-mono text-18pt text-green text-right text-nowrap">
                {item.quantity * item.product.salePrice} AED
              </div>
            </div>
          ))}
        {/* Invoice Summary */}
        <div
          className={hideItems ? "space-y-1" : "mt-2 md:mt-4 lg:mt-8 space-y-1"}
        >
          <div className="grid grid-cols-[8fr_1fr] lg:grid-cols-[4fr_1fr] gap-10 bg-[#fff]">
            <div className="font-mono text-18pt">
              Subtotal{" "}
              {(cart?.invoice?.discountAmount > 0 ||
                cart?.invoice?.specialDiscountAmount > 0) && (
                <span className="text-14pt">(Before discount)</span>
              )}{" "}
            </div>
            <div className="font-mono text-18pt text-right text-nowrap">
              {cart?.invoice?.subTotalBeforeDiscount || 0} AED
            </div>
          </div>

          {cart?.invoice?.discountAmount > 0 && (
            <div className="grid grid-cols-[4fr_1fr] gap-10 bg-[#fff]">
              <div className="font-mono text-18pt">Coupon Discount</div>
              <div className="font-mono text-18pt text-right text-nowrap">
                - {cart?.invoice?.discountAmount || 0} AED
              </div>
            </div>
          )}
          {cart?.invoice?.specialDiscountAmount > 0 && (
            <div className="grid grid-cols-[4fr_1fr] gap-10 bg-[#fff]">
              <div className="font-mono text-18pt">Special Discount</div>
              <div className="font-mono text-18pt text-right text-nowrap">
                - {cart?.invoice?.specialDiscountAmount || 0} AED
              </div>
            </div>
          )}
          {(cart?.invoice?.discountAmount > 0 ||
            cart?.invoice?.specialDiscountAmount > 0) && (
            <div className="grid grid-cols-[8fr_1fr] lg:grid-cols-[4fr_1fr] gap-10 bg-[#fff]">
              <div className="font-mono text-18pt">
                Subtotal{" "}
                {(cart?.invoice?.discountAmount > 0 ||
                  cart?.invoice?.specialDiscountAmount > 0) && (
                  <span className="text-14pt">(After discount)</span>
                )}{" "}
              </div>
              <div className="font-mono text-18pt text-right text-nowrap">
                {cart?.invoice?.subTotal || 0} AED
              </div>
            </div>
          )}
          {(cart?.invoice?.depositAmount > 0 &&
            (cart?.invoice?.depositAmountFromPreviousSubscription != 1 ||
              cart?.invoice?.depositAmountFromPreviousSubscription != "1")) && (
              <div
                className="grid grid-cols-[4fr_1fr] gap-10 bg-[#fff]"
                id="delivery-fee"
              >
                <div className="font-mono text-18pt">
                  Deposit <span className="text-14pt">(Refundable)</span>
                </div>
                <div className="font-mono text-18pt text-right text-nowrap ">
                  {cart?.invoice?.depositAmount || 0} AED
                </div>
              </div>
            )}
          <div className="grid grid-cols-[4fr_1fr] gap-10 bg-[#fff]">
            <div className="font-mono text-18pt">VAT</div>
            <div className="font-mono text-18pt text-right text-nowrap">
              {cart?.invoice?.vatAmount || 0} AED
            </div>
          </div>

          {cart?.shippingAddress &&
            cart?.invoice?.shippingCharges > 0 &&
            location.pathname != "/express-checkout-address" && (
              <div
                className="grid grid-cols-[4fr_1fr] gap-10 bg-[#fff]"
                id="delivery-fee"
              >
                <div className="font-mono text-18pt">Delivery charges</div>
                <div className="font-mono text-18pt text-right text-nowrap ">
                  {cart?.invoice?.shippingCharges || 0} AED
                </div>
              </div>
            )}
          {!cart?.shippingAddress &&
            cart?.invoice?.shippingCharges > 0 &&
            location.pathname === "/express-checkout-address" && (
              <div
                className="grid grid-cols-[4fr_1fr] gap-10 bg-[#fff]"
                id="delivery-fee"
              >
                <div className="font-mono text-18pt">Delivery charges</div>
                <div className="font-mono text-18pt text-right text-nowrap ">
                  {cart?.invoice?.shippingCharges || 0} AED
                </div>
              </div>
            )}
          {!hidePromo && (
            <PromoCodeSection
              cartId={cart?._id || ""}
              mealSubscriptionCartId={mealCartId || ""}
              appliedCoupon={
                cart?.appliedSubscriptionCoupon?.couponCode ||
                cart?.appliedOrderCoupon?.couponCode ||
                ""
              }
            />
          )}
        </div>
        {/* Total */}
        <div className="mt-2 md:mt-4 lg:mt-8">
          <div className="grid grid-cols-[3fr_1fr] gap-10 bg-[#fff]">
            <div className="text-21pt text-orange">Total</div>
            <div className="text-21pt text-right text-orange text-nowrap">
              {cart?.invoice?.totalAmount || 0} AED
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default CartSummary;
